// Mock data for A Team Cleaning Service

// Service Categories
export const serviceCategories = [
  {
    id: 'residential',
    name: 'Residential Cleaning',
    description: 'Professional cleaning services for homes and apartments',
    icon: 'Home'
  },
  {
    id: 'commercial',
    name: 'Commercial Cleaning',
    description: 'Professional cleaning services for businesses and commercial spaces',
    icon: 'Building2'
  }
];

// Residential Services - Competitive GTA Pricing (matching market rates)
export const residentialServices = [
  {
    id: 'regular-cleaning',
    category: 'residential',
    name: 'Regular House Cleaning',
    description: 'Routine cleaning to keep your home fresh and tidy',
    features: ['Dusting & vacuuming', 'Kitchen & bathroom cleaning', 'Floor mopping', 'Trash removal'],
    pricing: { oneTime: 88, weekly: 68, biWeekly: 76, monthly: 82, bedroom: 20, bathroom: 16, sqft: 0.03 },
    icon: 'Home'
  },
  {
    id: 'deep-cleaning',
    category: 'residential',
    name: 'Deep Cleaning',
    description: 'Thorough cleaning for every corner of your home',
    features: ['All regular cleaning tasks', 'Baseboards & crown molding', 'Inside appliances', 'Window sills & tracks'],
    pricing: { oneTime: 149, weekly: 108, biWeekly: 117, monthly: 127, bedroom: 26, bathroom: 23, sqft: 0.05 },
    icon: 'Sparkles'
  },
  {
    id: 'move-cleaning',
    category: 'residential',
    name: 'Move In/Out Cleaning',
    description: 'Complete cleaning for moving transitions',
    features: ['Empty property cleaning', 'All surfaces sanitized', 'Cabinets inside & out', 'Ready for new occupants'],
    pricing: { oneTime: 182, weekly: 133, biWeekly: 147, monthly: 159, bedroom: 29, bathroom: 23, sqft: 0.05 },
    icon: 'Truck'
  },
  {
    id: 'airbnb-cleaning',
    category: 'residential',
    name: 'Airbnb/Rental Turnover',
    description: 'Quick turnover cleaning for short-term rentals',
    features: ['Linen change', 'Full sanitization', 'Restocking amenities', 'Guest-ready preparation'],
    pricing: { oneTime: 95, weekly: 68, biWeekly: 76, monthly: 82, bedroom: 20, bathroom: 16, sqft: 0.03 },
    icon: 'Key'
  }
];

// Commercial Services - Competitive GTA Pricing (matching market rates)
export const commercialServices = [
  {
    id: 'office-cleaning',
    category: 'commercial',
    name: 'Office Cleaning',
    description: 'Professional cleaning for office spaces',
    features: ['Desk & surface cleaning', 'Restroom sanitization', 'Floor care', 'Common area maintenance'],
    pricing: { oneTime: 121, weekly: 88, biWeekly: 98, monthly: 108, room: 23, bathroom: 18, sqft: 0.04 },
    icon: 'Building2'
  },
  {
    id: 'retail-cleaning',
    category: 'commercial',
    name: 'Retail Store Cleaning',
    description: 'Keep your retail space spotless for customers',
    features: ['Display cleaning', 'Floor polishing', 'Window cleaning', 'Fitting room sanitization'],
    pricing: { oneTime: 133, weekly: 98, biWeekly: 108, monthly: 117, room: 24, bathroom: 20, sqft: 0.04 },
    icon: 'Store'
  },
  {
    id: 'daycare-cleaning',
    category: 'commercial',
    name: 'Daycare Cleaning',
    description: 'Safe and thorough cleaning for childcare facilities',
    features: ['Child-safe disinfection', 'Toy sanitization', 'Play area deep clean', 'Restroom sanitization'],
    pricing: { oneTime: 153, weekly: 111, biWeekly: 121, monthly: 133, room: 26, bathroom: 21, sqft: 0.05 },
    icon: 'Baby'
  },
  {
    id: 'medical-cleaning',
    category: 'commercial',
    name: 'Medical/Dental Office',
    description: 'Healthcare-grade cleaning and sanitization',
    features: ['Medical-grade disinfection', 'Biohazard handling', 'Waiting room cleaning', 'Exam room sanitization'],
    pricing: { oneTime: 173, weekly: 127, biWeekly: 140, monthly: 153, room: 29, bathroom: 23, sqft: 0.05 },
    icon: 'Stethoscope'
  },
  {
    id: 'construction-cleaning',
    category: 'commercial',
    name: 'Post-Construction Cleaning',
    description: 'Detailed cleaning after renovation or construction',
    features: ['Dust & debris removal', 'Surface polishing', 'Paint & sticker removal', 'Final detailing'],
    pricing: { oneTime: 185, weekly: null, biWeekly: null, monthly: null, room: 32, bathroom: 26, sqft: 0.05 },
    icon: 'HardHat'
  }
];

// Combined services for backwards compatibility
export const services = [...residentialServices, ...commercialServices];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    rating: 5,
    comment: 'A Team Cleaning Service transformed my home! Professional, thorough, and friendly staff.',
    service: 'Deep Cleaning'
  },
  {
    id: 2,
    name: 'Michael Chen',
    rating: 5,
    comment: 'Best office cleaning service in town. Our workspace has never looked better!',
    service: 'Office Cleaning'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    rating: 5,
    comment: 'The move-out cleaning was exceptional. Got my full deposit back thanks to their work!',
    service: 'Move In/Out Cleaning'
  }
];

export const mockBookings = [];
